import { css } from 'linaria';

export const tabListWrapper = css`
  width: 100%;
  padding-top: 32px;
  padding-bottom: 40px;
  @media (--to-tablet) {
    padding-bottom: 32px;
  }
  @media (--only-mobile) {
    padding: 24px 0;
  }

  && button {
    @media (--only-mobile) {
      padding: 5px 12px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const fixedTabListWrapper = css`
  padding-left: calc((100% - 1180px) / 2);
  margin-left: calc((100% - 1180px) / -2);
  background-color: var(--background-primary);
  @media (--only-desktop) {
    padding-left: calc((100% - 940px) / 2);
    margin-left: calc((100% - 940px) / -2);
  }
  @media (--to-tablet) {
    padding-right: calc((100% - 660px) / 2);
    padding-left: calc((100% - 660px) / 2);
    margin-right: calc((100% - 660px) / -2);
    margin-left: calc((100% - 660px) / -2);
  }
  @media (--only-mobile) {
    padding-right: calc((100% - 90vw) / 2);
    padding-left: calc((100% - 90vw) / 2);
    margin-right: calc((100% - 90vw) / -2);
    margin-left: calc((100% - 90vw) / -2);
  }
`;

export const header = css`
  margin: 0;
  @media (--only-mobile) {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const buttonWrapper = css`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 80px;

  @media (--to-tablet) {
    margin-bottom: 48px;
  }
`;

export const button = css`
  && {
    @media (--only-mobile) {
      padding: 10px 20px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const descriptionInfoBlockStylesMap: Record<number, string> = {
  4: css`
    && {
      grid-row-start: 4;
    }
  `,
  6: css`
    && {
      grid-row-start: 5;
    }
  `,
};

export const calculatorInfoBlockStylesMap: Record<number, string> = {
  4: css`
    && {
      grid-row-start: 4;

      @media (--to-tablet) {
        grid-row-start: 5;
      }
    }
  `,
  6: css`
    && {
      grid-row-start: 5;

      @media (--to-tablet) {
        grid-row-start: 6;
      }
    }
  `,
}
